import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography } from '@mui/material';
import {
    Error as ErrorIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { HF_ICON_SIZES } from '@root/app/shared/theme/designTokens';
import CloseableDialogTitle from '../hf-closeable-dialog-title/CloseableDialogTitle';
import HfButton from '@root/app/shared/new-components/hf-button/HfButton';

interface ErrorDialogProps {
    open: boolean;
    message: string;
    onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, message, onClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2
                }
            }}
        >
            <CloseableDialogTitle
                icon={<ErrorIcon sx={{ fontSize: HF_ICON_SIZES.xl }} color='error' />}
                title={t('ERROR')}
                onClose={onClose}
            />
            <DialogContent>
                <Typography variant='body2' color='text.primary'>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <HfButton
                    onClick={onClose}
                    intent='primary'
                    autoFocus
                >
                    {t('CLOSE')}
                </HfButton>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialog;

